import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { RadarChart as ERadar } from "echarts/charts";
import { TooltipComponent, RadarComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([ERadar, TooltipComponent, RadarComponent, CanvasRenderer]);

interface RadarChartProps {
  scores: {
    federal: number;
    estadual: number;
    documentos: number;
    obrigacoes: number;
    contingencias: number;
    regime_reforma: number;
  };
  height?: number;
}

const AXIS_LABELS = ["Federal", "Estadual", "Documentos", "Obrigacoes", "Contingencias", "Regime"];

export function FiscalRadarChart({ scores, height = 300 }: RadarChartProps) {
  const values = [
    scores.federal, scores.estadual, scores.documentos,
    scores.obrigacoes, scores.contingencias, scores.regime_reforma,
  ];

  const option = {
    tooltip: { trigger: "item" },
    radar: {
      indicator: AXIS_LABELS.map((name) => ({ name, max: 100 })),
      shape: "polygon",
      axisLine: { lineStyle: { color: "#e2e8f0" } },
      splitLine: { lineStyle: { color: "#f1f5f9" } },
      splitArea: { areaStyle: { color: ["#ffffff", "#f8fafc"] } },
      axisName: { color: "#475569", fontSize: 11 },
    },
    series: [
      {
        type: "radar",
        data: [
          {
            value: values,
            name: "Fiscal Health",
            areaStyle: { color: "rgba(59, 130, 246, 0.15)" },
            lineStyle: { color: "#3b82f6", width: 2 },
            itemStyle: { color: "#3b82f6" },
          },
        ],
      },
    ],
  };

  return <ReactEChartsCore echarts={echarts} option={option} style={{ height }} />;
}
